import React from "react";
import "./card2.css";
import { Typography } from "@mui/material";

function Card2(props) {
  return (
    <div className="menu__container">
      <div className="menu">
        {/* <img src="https://img.icons8.com/dotty/120/ffffff/1-circle.png" />*/}
        <Typography variant="p" sx={{ fontSize: "24px" }} align="center">
          {props.name1}
          <br></br>
          <br></br>
          {props.name2}
          <br></br>
          <br></br>
          <Typography variant="h3">{props.emoji}</Typography>
        </Typography>
      </div>
    </div>
  );
}

export default Card2;
